import React, { Fragment, FunctionComponent, useMemo } from 'react';
import { PackageOldPrice } from '../PackageOldPrice';
import {
  FullPrice,
  PriceBlock,
  PriceDifference,
  PriceDroppedIcon,
  PriceGrowIcon,
  PriceMovementView,
  StyledPackageHotPrice,
  StyledInstantConfirm,
} from './PackagePrice.style';
import { PriceMovementStatus } from './PackagePrice.types';
import { useGetPackageData, useGetLinkToPackage } from '../../hooks';

type Props = {
  currentPrice: number;
  oldPrice?: number;
  className?: string;
  discount: boolean;
  instantConfirm: boolean;
};

export const PackagePrice: FunctionComponent<Props> = ({
  oldPrice,
  currentPrice,
  className,
  discount,
  instantConfirm,
}) => {
  const { linkToPackage } = useGetLinkToPackage();

  const priceMovementStatus = useMemo(() => {
    if (!oldPrice || oldPrice === currentPrice || discount) {
      return PriceMovementStatus.NO_CHANGE;
    }

    if (oldPrice < currentPrice) {
      return PriceMovementStatus.INCREASED;
    }

    return PriceMovementStatus.DECREASED;
  }, [oldPrice, currentPrice, discount]);

  const priceDifference = useMemo(() => {
    if (!oldPrice || priceMovementStatus === PriceMovementStatus.NO_CHANGE) {
      return undefined;
    }
    const price = currentPrice - oldPrice;

    if (price < 0) {
      return undefined;
    }

    return price;
  }, [oldPrice, priceMovementStatus, currentPrice]);

  const showPriceMovement = useMemo(
    () => priceMovementStatus !== PriceMovementStatus.NO_CHANGE,
    [priceMovementStatus]
  );
  const { packageData } = useGetPackageData();

  return (
    <div>
      <PriceBlock className={className}>
        {instantConfirm && <StyledInstantConfirm />}
        <FullPrice
          onClick={() => {
            window.open(linkToPackage, '_blank');
          }}
          value={currentPrice}
        />
        {discount && <StyledPackageHotPrice value={oldPrice} />}
        {!discount && <PackageOldPrice value={oldPrice} />}
      </PriceBlock>
      {showPriceMovement && (
        <Fragment>
          {priceMovementStatus === PriceMovementStatus.DECREASED && (
            <PriceMovementView>
              <PriceDroppedIcon />
              {packageData?.search_type === 'hotel'
                ? 'Ура! Цена на отель снизилась на'
                : 'Ура! Цена на тур снизилась на'}
              <PriceDifference value={priceDifference} />
            </PriceMovementView>
          )}
          {priceMovementStatus === PriceMovementStatus.INCREASED && (
            <PriceMovementView>
              <PriceGrowIcon />
              {packageData?.search_type === 'hotel' ? 'Отель подорожал!' : 'Тур подорожал!'}
            </PriceMovementView>
          )}
        </Fragment>
      )}
    </div>
  );
};
